import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import CloseIcon from '../../Icons/CloseBold';
import { IconSize } from '../../Icons/IconWrap';
import Tag from '../Tag';
const RemovableTag = (_param)=>{
    var rest = _extends({}, _param);
    return /*#__PURE__*/ React.createElement(Tag, _extends({
        postfix: /*#__PURE__*/ React.createElement(CloseIcon, {
            size: IconSize.TINY
        })
    }, rest));
};
RemovableTag.displayName = 'RemovableTag';
export default RemovableTag;
